// extracted by mini-css-extract-plugin
export default {"profile-container":"Profile_profile-container__4N2GX","student":"Profile_student__RquMJ"};